import _ from 'lodash'

export const enumFormat = (enumString: String) => {
  return enumString.replace(/_/g, ' ')
}

export const stringValues = <A extends unknown>(eenum: A): string[] => {
  return _.values(eenum)
}
